import { PAGE_CODES } from 'constants/pageCodes';
import { lazyWithRetry } from 'utils/chunkLoadRecovery';
import { EnhancedPath } from 'utils/history';

const COMPANY_MANAGER_ROUTING_PATHS = {
  tab: 'tab',
};

export class CompanyManagerPaths {
  static companyManager = new EnhancedPath('/company-manager');

  // Each tab is its own deep-linkable URL (`/company-manager/<tab>`). The `:tab?` is optional so a
  // bare `/company-manager` still matches; the page redirects it to the default tab. Mirrors the
  // SubCompanyPage routed-tab pattern (react-guidelines: tabbed pages are URL-routed).
  static companyManagerTab = new EnhancedPath(
    `${CompanyManagerPaths.companyManager.path}/:${COMPANY_MANAGER_ROUTING_PATHS.tab}?`,
  );
}

const routesConfig = {
  settings: {
    layout: {},
  },
  routes: [
    {
      path: CompanyManagerPaths.companyManagerTab.path,
      component: lazyWithRetry(() => import('app/pages/companyManager')),
      pageCode: PAGE_CODES.COMPANY_MANAGER,
    },
  ],
};

export default routesConfig;
